import { t } from 'i18next';
import React from 'react';

const Copyright = () => {
  return (
    <div className="container-fluid copyright py-4">
      <div className="container">
        <div className="row">
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            &copy;  {t('all_rights_reserved')}<a className="fw-medium" href="#">{t('atilal_company')}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Copyright;